"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return LoaderLifestyleX;
    }
});
var _jsxruntime = require("react/jsx-runtime");
var _graphics = require("../../assets/graphics");
var _styled = /*#__PURE__*/ _interop_require_default(require("@emotion/styled"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var Container = _styled.default.div("\nsvg {\n    margin: 20px;\n    -webkit-animation-name: spin;\n    -webkit-animation-duration: 1000ms;\n    -webkit-animation-iteration-count: infinite;\n    -webkit-animation-timing-function: linear;\n    -moz-animation-name: spin;\n    -moz-animation-duration: 1000ms;\n    -moz-animation-iteration-count: infinite;\n    -moz-animation-timing-function: linear;\n    -ms-animation-name: spin;\n    -ms-animation-duration: 1000ms;\n    -ms-animation-iteration-count: infinite;\n    -ms-animation-timing-function: linear;\n    animation-name: spin;\n    animation-duration: 1000ms;\n    animation-iteration-count: infinite;\n    animation-timing-function: linear;\n}\n@-ms-keyframes spin {\n    0% {\n        -ms-transform: rotate(0deg);\n    }\n    100% {\n        -ms-transform: rotate(360deg);\n    }\n}\n@-moz-keyframes spin {\n    0% {\n        -moz-transform: rotate(0deg);\n    }\n    100% {\n        -moz-transform: rotate(360deg);\n    }\n}\n@-webkit-keyframes spin {\n    0% {\n        -webkit-transform: rotate(0deg);\n    }\n    100% {\n        -webkit-transform: rotate(360deg);\n    }\n}\n@keyframes spin {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}\n");
function LoaderLifestyleX() {
    return /*#__PURE__*/ (0, _jsxruntime.jsx)(Container, {
        children: /*#__PURE__*/ (0, _jsxruntime.jsx)(_graphics.Loader, {})
    });
}
